// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Montserrat', sans-serif !important;
  box-sizing: border-box;
}

body.dh-theme-dark .dhp-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  position: relative;
}

body.dh-theme-light .dhp-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);
  position: relative;
}


.dhp-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  position: relative;
}

.dhp-content {
  position: relative;
  z-index: 1;
  padding: 20px;
  width: 100%;
  max-width: 1600px;
  margin: auto;
  background: transparent;
}

.dhp-background-animation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.dhp-shape {
  position: absolute;
  opacity: 0.1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  animation: dhp-float 20s infinite linear;
}

.dhp-shape-1 { width: 200px; height: 200px; top: 10%; left: 10%; }
.dhp-shape-2 { width: 150px; height: 150px; top: 60%; right: 10%; animation-delay: -5s; }
.dhp-shape-3 { width: 100px; height: 100px; bottom: 20%; left: 20%; animation-delay: -10s; }

@keyframes dhp-float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-20px) rotate(90deg); }
  50% { transform: translateY(0) rotate(180deg); }
  75% { transform: translateY(20px) rotate(270deg); }
}

.dhp-main-layout {
  display: flex;
  gap: 20px;
  height: calc(100vh - 130px);
  overflow: hidden;
  margin-top: 20px;
}

.dhp-left-column {
  width: 400px;
  height: 900px;
}

.dhp-groups-panel {
  background: white;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 720px;
  margin-bottom: 15px;
}

.dhp-left-panel-nav {
  display: flex;
  gap: 8px;
  padding: 16px 24px 0 24px;
  border-bottom: 1px solid #e2e8f0;
  background: white;
}

.dhp-nav-btn {
  padding: 10px 20px;
  background: none;
  border: none;
  border-radius: 8px 8px 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dhp-nav-btn:hover {
  color: #002FA7;
  background: #f8fafc;
}

.dhp-nav-btn.active {
  color: #002FA7;
  background: #f0f7ff;
  position: relative;
}

.dhp-nav-btn.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #002FA7;
}

.dhp-left-panel-content {
  flex: 1 1;
  overflow-y: auto;
}

.dhp-department-view {
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.dhp-department-header-info {
  text-align: center;
  padding-bottom: 16px;
}

.dhp-department-name {
  font-size: 20px;
  font-weight: 700;
  color: #002FA7;
  margin: 0 0 16px 0;
}

.dhp-department-stats {
  display: flex;
  justify-content: space-around;
  gap: 16px;
}

.dhp-department-stat {
  text-align: center;
  flex: 1 1;
}

.dhp-stat-number {
  font-size: 28px;
  font-weight: 700;
  color: #002FA7;
  display: block;
  margin-bottom: 4px;
}

.dhp-stat-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.dhp-department-specialities {
  background: #f8fafc;
  border-radius: 16px;
  padding: 16px;
}

.dhp-specialities-title {
  font-size: 14px;
  font-weight: 600;
  color: #002FA7;
  margin: 0 0 12px 0;
}

.dhp-specialities-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dhp-speciality-item {
  padding: 8px 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.dhp-speciality-name {
  font-size: 13px;
  color: #1f2937;
  font-weight: 500;
}

.dhp-combined-metric-card {
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-radius: 20px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  margin: 8px 0;
}

.dhp-combined-metric-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px dashed #e2e8f0;
}

.dhp-combined-metric-title {
  font-size: 16px;
  font-weight: 600;
  color: #002FA7;
}

.dhp-combined-metrics {
  display: flex;
  gap: 20px;
}

.dhp-combined-metric-item {
  flex: 1 1;
  text-align: center;
}

.dhp-combined-metric-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  margin-bottom: 8px;
}

.dhp-combined-metric-value {
  font-size: 28px;
  font-weight: 700;
  color: #002FA7;
  margin-bottom: 12px;
}

.dhp-combined-metric-progress {
  margin-top: 8px;
}

.dhp-combined-metric-divider {
  width: 1px;
  background: #e2e8f0;
}

.dhp-progress-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.dhp-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #002FA7 0%, #3b82f6 100%);
  border-radius: 4px;
  transition: width 0.3s ease;
}

.dhp-quick-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
}

.dhp-quick-link-btn {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  text-align: left;
}

.dhp-quick-link-btn:hover {
  transform: translateX(4px);
  border-color: #002FA7;
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);
  background: #f8fafc;
}

.dhp-quick-link-btn.active {
  background: #f0f7ff;
  border-color: #002FA7;
  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.1);
}

.dhp-quick-link-btn.active .dhp-quick-link-title {
  color: #002FA7;
}

.dhp-quick-link-btn.active .dhp-quick-link-arrow {
  color: #002FA7;
  transform: translateX(4px);
}

.dhp-quick-link-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dhp-quick-link-title {
  font-size: 16px;
  font-weight: 600;
  color: #002FA7;
}

.dhp-quick-link-description {
  font-size: 12px;
  color: #64748b;
}

.dhp-quick-link-arrow {
  font-size: 20px;
  color: #64748b;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.dhp-quick-link-btn:hover .dhp-quick-link-arrow {
  transform: translateX(4px);
  color: #002FA7;
}

.dhp-groups-header {
  padding: 24px 24px 16px;
  border-bottom: 1px solid #e2e8f0;
}

.dhp-groups-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
}

.dhp-groups-title {
  font-size: 20px;
  font-weight: 700;
  color: #002FA7;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.dhp-groups-count {
  background: #e0e7ff;
  color: #002FA7;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
}

.dhp-add-group-icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #002FA7;
  color: white;
  border: none;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 47, 167, 0.2);
}

.dhp-add-group-icon-btn:hover {
  background: #1e40af;
  transform: scale(1.05);
}

.dhp-search-input {
  width: 100%;
  padding: 10px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: white;
  color: #1f2937;
}

.dhp-search-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.dhp-course-filter {
  display: flex;
  gap: 4px;
  padding: 14px 20px;
  flex-wrap: wrap;
  border-bottom: 1px solid #e2e8f0;
}

.dhp-course-filter-btn {
  padding: 6px 10px;
  border: 1px solid #e2e8f0;
  background: white;
  color: #64748b;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dhp-course-filter-btn:hover {
  border-color: #002FA7;
  color: #002FA7;
}

.dhp-course-filter-btn.active {
  background: #002FA7;
  color: white;
  border-color: #002FA7;
}

.dhp-groups-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px 24px;
}

.dhp-course-group {
  margin-bottom: 24px;
}

.dhp-course-title {
  font-size: 16px;
  font-weight: 600;
  color: #002FA7;
  margin: 0 0 12px 0;
  padding-bottom: 6px;
  border-bottom: 2px dashed #e2e8f0;
}

.dhp-groups-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.dhp-group-card {
  background: white;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dhp-group-card:hover {
  border-color: #002FA7;
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);
}

.dhp-group-card.active {
  border-color: #002FA7;
  background: #f0f7ff;
  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);
}

.dhp-group-badge {
  background: #002FA7;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
  display: inline-block;
}

.dhp-group-info-compact {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}

.dhp-info-compact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.dhp-info-label-compact {
  color: #64748b;
  font-weight: 500;
}

.dhp-info-value-compact {
  color: #1f2937;
  font-weight: 600;
  text-align: right;
  max-width: 60%;
  word-break: break-word;
}

.dhp-detail-panel {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 24px;
  overflow: hidden;
}

.dhp-detail-tabs {
  display: flex;
  gap: 4px;
  padding: 16px 24px 0 24px;
  border-bottom: 1px solid #e2e8f0;
  background: white;
  position: sticky;
  top: 0;
  flex-wrap: wrap;
}

.dhp-detail-tab {
  padding: 10px 20px;
  background: none;
  border: none;
  border-radius: 8px 8px 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dhp-detail-tab:hover {
  color: #002FA7;
  background: #f8fafc;
}

.dhp-detail-tab.active {
  color: #002FA7;
  background: #f0f7ff;
  position: relative;
}

.dhp-detail-tab.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #002FA7;
}

.dhp-detail-content {
  flex: 1 1;
  overflow-y: auto;
}

.dhp-info-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 60px 40px;
  height: 100%;
  min-height: 500px;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-radius: 24px;
}

.dhp-info-placeholder h3 {
  font-size: 24px;
  font-weight: 600;
  color: #002FA7;
  margin: 0 0 16px 0;
}

.dhp-info-placeholder p {
  font-size: 16px;
  color: #64748b;
  max-width: 400px;
  margin: 0;
  line-height: 1.5;
}

.dhp-cache-warning {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  margin: 10px 20px;
  background: rgba(255, 193, 7, 0.15);
  border: 1px solid rgba(255, 193, 7, 0.3);
  border-radius: 12px;
}

.dhp-cache-warning-text {
  flex: 1 1;
  color: #ffc107;
}

.dhp-cache-warning-btn {
  padding: 6px 16px;
  background: rgba(255, 193, 7, 0.2);
  border: 1px solid #ffc107;
  border-radius: 8px;
  color: #ffc107;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dhp-loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #002FA7;
  border-radius: 50%;
  animation: dhp-spin 1s linear infinite;
  margin-bottom: 16px;
}

.dhp-loading-spinner-small {
  width: 32px;
  height: 32px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #002FA7;
  border-radius: 50%;
  animation: dhp-spin 1s linear infinite;
  margin-bottom: 12px;
}

@keyframes dhp-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.dhp-loading-container,
.dhp-department-loading,
.dhp-department-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.dhp-retry-btn {
  margin-top: 12px;
  padding: 8px 20px;
  background: #002FA7;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
}

.dhp-no-groups {
  text-align: center;
  padding: 48px 24px;
  background: #f8fafc;
  border-radius: 12px;
  border: 2px dashed #e2e8f0;
  color: #64748b;
}

.dhp-department-groups-full {
  height: 100%;
  overflow-y: auto;
}

@media (max-width: 1024px) {
  .dhp-left-column {
    min-width: 280px;
    max-width: 350px;
  }
  
  .dhp-combined-metrics {
    flex-direction: column;
    gap: 16px;
  }
  
  .dhp-combined-metric-divider {
    display: none;
  }
}

@media (max-width: 768px) {
  .dhp-main-layout {
    flex-direction: column;
    height: auto;
  }
  
  .dhp-left-column {
    min-width: 100%;
    max-width: 100%;
    height: auto;
  }
  
  .dhp-groups-panel {
    max-height: 60vh;
  }
  
  .dhp-detail-panel {
    min-height: 50vh;
  }
  
  .dhp-combined-metric-value {
    font-size: 24px;
  }
  
  .dhp-quick-link-btn {
    padding: 12px 16px;
  }
}

@media (max-width: 480px) {
  .dhp-department-view {
    padding: 16px;
  }
  
  .dhp-combined-metric-card {
    padding: 16px;
  }
  
  .dhp-combined-metric-value {
    font-size: 20px;
  }
  
  .dhp-group-card {
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/DepartmentHeadPageStyle.css"],"names":[],"mappings":"AAEA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;;AAGA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA,eAAe,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,SAAS,EAAE;AACjE,eAAe,YAAY,EAAE,aAAa,EAAE,QAAQ,EAAE,UAAU,EAAE,oBAAoB,EAAE;AACxF,eAAe,YAAY,EAAE,aAAa,EAAE,WAAW,EAAE,SAAS,EAAE,qBAAqB,EAAE;;AAE3F;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,0CAA0C,EAAE;EAClD,MAAM,uCAAuC,EAAE;EAC/C,MAAM,0CAA0C,EAAE;AACpD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');\n\n* {\n  font-family: 'Montserrat', sans-serif !important;\n  box-sizing: border-box;\n}\n\nbody.dh-theme-dark .dhp-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  position: relative;\n}\n\nbody.dh-theme-light .dhp-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);\n  position: relative;\n}\n\n\n.dhp-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  position: relative;\n}\n\n.dhp-content {\n  position: relative;\n  z-index: 1;\n  padding: 20px;\n  width: 100%;\n  max-width: 1600px;\n  margin: auto;\n  background: transparent;\n}\n\n.dhp-background-animation {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.dhp-shape {\n  position: absolute;\n  opacity: 0.1;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n  animation: dhp-float 20s infinite linear;\n}\n\n.dhp-shape-1 { width: 200px; height: 200px; top: 10%; left: 10%; }\n.dhp-shape-2 { width: 150px; height: 150px; top: 60%; right: 10%; animation-delay: -5s; }\n.dhp-shape-3 { width: 100px; height: 100px; bottom: 20%; left: 20%; animation-delay: -10s; }\n\n@keyframes dhp-float {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  25% { transform: translateY(-20px) rotate(90deg); }\n  50% { transform: translateY(0) rotate(180deg); }\n  75% { transform: translateY(20px) rotate(270deg); }\n}\n\n.dhp-main-layout {\n  display: flex;\n  gap: 20px;\n  height: calc(100vh - 130px);\n  overflow: hidden;\n  margin-top: 20px;\n}\n\n.dhp-left-column {\n  width: 400px;\n  height: 900px;\n}\n\n.dhp-groups-panel {\n  background: white;\n  border-radius: 24px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 720px;\n  margin-bottom: 15px;\n}\n\n.dhp-left-panel-nav {\n  display: flex;\n  gap: 8px;\n  padding: 16px 24px 0 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: white;\n}\n\n.dhp-nav-btn {\n  padding: 10px 20px;\n  background: none;\n  border: none;\n  border-radius: 8px 8px 0 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.dhp-nav-btn:hover {\n  color: #002FA7;\n  background: #f8fafc;\n}\n\n.dhp-nav-btn.active {\n  color: #002FA7;\n  background: #f0f7ff;\n  position: relative;\n}\n\n.dhp-nav-btn.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #002FA7;\n}\n\n.dhp-left-panel-content {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.dhp-department-view {\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.dhp-department-header-info {\n  text-align: center;\n  padding-bottom: 16px;\n}\n\n.dhp-department-name {\n  font-size: 20px;\n  font-weight: 700;\n  color: #002FA7;\n  margin: 0 0 16px 0;\n}\n\n.dhp-department-stats {\n  display: flex;\n  justify-content: space-around;\n  gap: 16px;\n}\n\n.dhp-department-stat {\n  text-align: center;\n  flex: 1;\n}\n\n.dhp-stat-number {\n  font-size: 28px;\n  font-weight: 700;\n  color: #002FA7;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.dhp-stat-label {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.dhp-department-specialities {\n  background: #f8fafc;\n  border-radius: 16px;\n  padding: 16px;\n}\n\n.dhp-specialities-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0 0 12px 0;\n}\n\n.dhp-specialities-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dhp-speciality-item {\n  padding: 8px 12px;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.dhp-speciality-name {\n  font-size: 13px;\n  color: #1f2937;\n  font-weight: 500;\n}\n\n.dhp-combined-metric-card {\n  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\n  border-radius: 20px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n  margin: 8px 0;\n}\n\n.dhp-combined-metric-header {\n  text-align: center;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 2px dashed #e2e8f0;\n}\n\n.dhp-combined-metric-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.dhp-combined-metrics {\n  display: flex;\n  gap: 20px;\n}\n\n.dhp-combined-metric-item {\n  flex: 1;\n  text-align: center;\n}\n\n.dhp-combined-metric-label {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.dhp-combined-metric-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: #002FA7;\n  margin-bottom: 12px;\n}\n\n.dhp-combined-metric-progress {\n  margin-top: 8px;\n}\n\n.dhp-combined-metric-divider {\n  width: 1px;\n  background: #e2e8f0;\n}\n\n.dhp-progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.dhp-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #002FA7 0%, #3b82f6 100%);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.dhp-quick-links {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.dhp-quick-link-btn {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 20px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n  text-align: left;\n}\n\n.dhp-quick-link-btn:hover {\n  transform: translateX(4px);\n  border-color: #002FA7;\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);\n  background: #f8fafc;\n}\n\n.dhp-quick-link-btn.active {\n  background: #f0f7ff;\n  border-color: #002FA7;\n  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.1);\n}\n\n.dhp-quick-link-btn.active .dhp-quick-link-title {\n  color: #002FA7;\n}\n\n.dhp-quick-link-btn.active .dhp-quick-link-arrow {\n  color: #002FA7;\n  transform: translateX(4px);\n}\n\n.dhp-quick-link-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dhp-quick-link-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #002FA7;\n}\n\n.dhp-quick-link-description {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.dhp-quick-link-arrow {\n  font-size: 20px;\n  color: #64748b;\n  transition: transform 0.3s ease;\n  flex-shrink: 0;\n}\n\n.dhp-quick-link-btn:hover .dhp-quick-link-arrow {\n  transform: translateX(4px);\n  color: #002FA7;\n}\n\n.dhp-groups-header {\n  padding: 24px 24px 16px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dhp-groups-title-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.dhp-groups-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #002FA7;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dhp-groups-count {\n  background: #e0e7ff;\n  color: #002FA7;\n  padding: 2px 8px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.dhp-add-group-icon-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: #002FA7;\n  color: white;\n  border: none;\n  font-size: 20px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 47, 167, 0.2);\n}\n\n.dhp-add-group-icon-btn:hover {\n  background: #1e40af;\n  transform: scale(1.05);\n}\n\n.dhp-search-input {\n  width: 100%;\n  padding: 10px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  background: white;\n  color: #1f2937;\n}\n\n.dhp-search-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.dhp-course-filter {\n  display: flex;\n  gap: 4px;\n  padding: 14px 20px;\n  flex-wrap: wrap;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dhp-course-filter-btn {\n  padding: 6px 10px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  color: #64748b;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.dhp-course-filter-btn:hover {\n  border-color: #002FA7;\n  color: #002FA7;\n}\n\n.dhp-course-filter-btn.active {\n  background: #002FA7;\n  color: white;\n  border-color: #002FA7;\n}\n\n.dhp-groups-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 24px;\n}\n\n.dhp-course-group {\n  margin-bottom: 24px;\n}\n\n.dhp-course-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0 0 12px 0;\n  padding-bottom: 6px;\n  border-bottom: 2px dashed #e2e8f0;\n}\n\n.dhp-groups-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.dhp-group-card {\n  background: white;\n  border-radius: 12px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.dhp-group-card:hover {\n  border-color: #002FA7;\n  transform: translateX(4px);\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.1);\n}\n\n.dhp-group-card.active {\n  border-color: #002FA7;\n  background: #f0f7ff;\n  box-shadow: 0 4px 12px rgba(0, 47, 167, 0.15);\n}\n\n.dhp-group-badge {\n  background: #002FA7;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 14px;\n  display: inline-block;\n}\n\n.dhp-group-info-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.dhp-info-compact {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n}\n\n.dhp-info-label-compact {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.dhp-info-value-compact {\n  color: #1f2937;\n  font-weight: 600;\n  text-align: right;\n  max-width: 60%;\n  word-break: break-word;\n}\n\n.dhp-detail-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 24px;\n  overflow: hidden;\n}\n\n.dhp-detail-tabs {\n  display: flex;\n  gap: 4px;\n  padding: 16px 24px 0 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: white;\n  position: sticky;\n  top: 0;\n  flex-wrap: wrap;\n}\n\n.dhp-detail-tab {\n  padding: 10px 20px;\n  background: none;\n  border: none;\n  border-radius: 8px 8px 0 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.dhp-detail-tab:hover {\n  color: #002FA7;\n  background: #f8fafc;\n}\n\n.dhp-detail-tab.active {\n  color: #002FA7;\n  background: #f0f7ff;\n  position: relative;\n}\n\n.dhp-detail-tab.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #002FA7;\n}\n\n.dhp-detail-content {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.dhp-info-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 60px 40px;\n  height: 100%;\n  min-height: 500px;\n  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);\n  border-radius: 24px;\n}\n\n.dhp-info-placeholder h3 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #002FA7;\n  margin: 0 0 16px 0;\n}\n\n.dhp-info-placeholder p {\n  font-size: 16px;\n  color: #64748b;\n  max-width: 400px;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.dhp-cache-warning {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  margin: 10px 20px;\n  background: rgba(255, 193, 7, 0.15);\n  border: 1px solid rgba(255, 193, 7, 0.3);\n  border-radius: 12px;\n}\n\n.dhp-cache-warning-text {\n  flex: 1;\n  color: #ffc107;\n}\n\n.dhp-cache-warning-btn {\n  padding: 6px 16px;\n  background: rgba(255, 193, 7, 0.2);\n  border: 1px solid #ffc107;\n  border-radius: 8px;\n  color: #ffc107;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.dhp-loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid #002FA7;\n  border-radius: 50%;\n  animation: dhp-spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n.dhp-loading-spinner-small {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #002FA7;\n  border-radius: 50%;\n  animation: dhp-spin 1s linear infinite;\n  margin-bottom: 12px;\n}\n\n@keyframes dhp-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.dhp-loading-container,\n.dhp-department-loading,\n.dhp-department-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.dhp-retry-btn {\n  margin-top: 12px;\n  padding: 8px 20px;\n  background: #002FA7;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.dhp-no-groups {\n  text-align: center;\n  padding: 48px 24px;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 2px dashed #e2e8f0;\n  color: #64748b;\n}\n\n.dhp-department-groups-full {\n  height: 100%;\n  overflow-y: auto;\n}\n\n@media (max-width: 1024px) {\n  .dhp-left-column {\n    min-width: 280px;\n    max-width: 350px;\n  }\n  \n  .dhp-combined-metrics {\n    flex-direction: column;\n    gap: 16px;\n  }\n  \n  .dhp-combined-metric-divider {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .dhp-main-layout {\n    flex-direction: column;\n    height: auto;\n  }\n  \n  .dhp-left-column {\n    min-width: 100%;\n    max-width: 100%;\n    height: auto;\n  }\n  \n  .dhp-groups-panel {\n    max-height: 60vh;\n  }\n  \n  .dhp-detail-panel {\n    min-height: 50vh;\n  }\n  \n  .dhp-combined-metric-value {\n    font-size: 24px;\n  }\n  \n  .dhp-quick-link-btn {\n    padding: 12px 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .dhp-department-view {\n    padding: 16px;\n  }\n  \n  .dhp-combined-metric-card {\n    padding: 16px;\n  }\n  \n  .dhp-combined-metric-value {\n    font-size: 20px;\n  }\n  \n  .dhp-group-card {\n    padding: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
